import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import "./Board.css";
import {
  Accordion,
  Button,
  Col,
  Form,
  Row,
  useAccordionButton,
} from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Temporizador from "./TemporizadorOrd";
import { Timestamp } from "firebase/firestore";
import { addNotifyOrden } from "../util/UtilsFirebase";

export default function ItemBoard({
  item,
  index,
  escala,
  moveItem,
  minimizeItem,
  setOrdImprimir,
  updatePlatillo,
}) {
  const [ordenes, setOrdenes] = useState([]);
  const [cancel, setCancel] = useState("");
  const [platillCan, setPlatillCan] = useState();
  const [nota, setNota] = useState("");
  const [motivo, setMotivo] = useState(0);
  const motivos = [
    "Cliente cancelo",
    "Demora excesiva",
    "Producto no disponible",
    "Error en la orden",
    "Problema en cocina",
    "Otro motivo",
  ];

  const estilos = {
    contenedor: {
      transform: "scale(" + escala + ")",
      transformOrigin: "center center",
      flex: "0 0 calc(33.333% - 10px)",
      transition: "transform 0.2s ease",
      // zIndex: 1066,
    },
    ventana: {
      transform: "scale(" + escala + ")",
      transformOrigin: "center center",
      backgroundColor: "#fff",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
      overflow: "hidden",
      // transition: "transform 0.2s ease",
      width: "32rem",
      // cursor: "grab",
      border: "1px solid #ccc",
      position: "sticky",
      // zIndex: 1066,
    },
    header: {
      borderBottom: "1px solid",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      cursor: "move",
    },
    contenido: {
      maxHeight: "40rem",
      padding: "20px",
      overflowY: "auto",
    },
    botonCerrar: {
      background: "transparent",
      border: "none",
      color: "#000",
      cursor: "pointer",
      fontWeight: "bold",
    },
  };

  const handleChange = (event) => {
    const index = event.target.selectedIndex;
    setMotivo(index);
  };

  const Llamada = (orden) => {
    let notificacion = {};
    let msg = "¿Requiere la presencia del cliente?";
    notificacion = {
      idv4: uuidv4(),
      turno_id: orden.id,
      user: orden.user,
      user_name: orden.user_name,
      status: "AVISO",
      number: orden.number,
      puesto_name: orden.puesto_name,
      tipo_pago: orden.tipo_pago,
      description: "Se requiere de su presencia en " + orden.puesto_name,
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      addNotifyOrden(notificacion);
    }
  };

  function CustomToggle({ text, eventKey, e }) {
    const decoratedOnClick = useAccordionButton(eventKey, (e) => {
      e.stopPropagation();
    });
    return (
      <h4
        className="section-title nonDrag"
        onClick={decoratedOnClick}
        style={{ textAlign: "center", cursor: "pointer" }}
      >
        Cancelados{" (" + text + ")"}
      </h4>
    );
  }

  useEffect(() => {
    const result = Object.groupBy(
      item?.detalle,
      (itemdet) => itemdet.selectedTime,
    );
    setOrdenes(result);
  }, [item.detalle]);

  return (
    <>
      {Object.keys(ordenes).map((items, index) => (
        <div style={estilos.contenedor}>
          <Draggable
            key={item.id}
            // defaultPosition={{ x: index * 515, y: 0 }}
            onStop={(e, data) => moveItem(item.id, data)}
            cancel=".nonDrag"
          >
            <div
              id={"itemdrg" + item.id}
              style={{
                transform: "scale(" + escala + ")",
                transformOrigin: "center center",
                backgroundColor: "#fff",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                borderRadius: "8px",
                overflow: "hidden",
                width: "28rem",
                height: "min-content",
                // cursor: "grab",
                border: "1px solid #ccc",
                position: "sticky",
                left: index * 512,
              }}
            >
              <div className="ventana-header" style={estilos.header}>
                <h5
                  className="nonDrag"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOrdImprimir({ ...item, detalle: ordenes[items] });
                  }}
                >
                  <i className="bx icon bx-printer"></i> Imprimir
                </h5>
                <h5 style={{ color: "orangered" }}>
                  <strong>Orden #{item.folio}</strong>
                </h5>
                <button
                  className="nonDrag"
                  style={estilos.botonCerrar}
                  onClick={() => minimizeItem(item.id)}
                >
                  X
                </button>
              </div>
              {cancel !== items + item.id ? (
                <div style={estilos.contenido}>
                  <Temporizador item={{ ...item, detalle: ordenes[items] }} />
                  <div className="nonDrag">
                    {ordenes[items]
                      ?.filter((item) => item.status !== "CANCELADO")
                      .map((itemdet) => (
                        <Row
                          className="nonDrag"
                          style={{
                            marginBottom: 8,
                            paddingTop: 3,
                            paddingBottom: 3,
                            border: "1px solid #ccc",
                            boxShadow: "0px 4px 7px rgba(0, 0, 0, 0.15)",
                            borderRadius: "10px",
                          }}
                        >
                          <Col
                            md={2}
                            style={{
                              justifyItems: "center",
                              alignContent: "space-evenly",
                            }}
                          >
                            <label className="marginlbl">
                              <img
                                id="logo_img"
                                src={itemdet.img}
                                width={"60rem"}
                                height={"70rem"}
                                style={{
                                  borderRadius: 10,
                                  objectFit: "cover",
                                }}
                                alt=""
                              />
                            </label>
                          </Col>
                          <Col
                            md={1}
                            style={{
                              justifyItems: "center",
                              alignContent: "space-evenly",
                            }}
                          >
                            <h3
                              style={{
                                textAlign: "center",
                                fontWeight: 600,
                                color: "orangered",
                              }}
                            >
                              {itemdet.cantidad}
                              <h6 style={{ color: "black" }}>pza</h6>
                            </h3>
                          </Col>
                          <Col md={8} style={{ alignContent: "center" }}>
                            <Row style={{ justifyContent: "center" }}>
                              <Col md={12}>
                                <h4
                                  style={{
                                    textAlign: "center",
                                    fontWeight: 700,
                                  }}
                                >
                                  {itemdet.name}
                                </h4>
                              </Col>
                              {itemdet.ingredientes &&
                                Object.keys(itemdet.ingredientes).length >
                                  0 && (
                                  <Col md={6}>
                                    <h6 style={{ color: "orangered" }}>
                                      <strong>Ingredientes:</strong>
                                    </h6>
                                    {Object.keys(itemdet.ingredientes).map(
                                      (element) => {
                                        return (
                                          <Row>
                                            <Col
                                              md={12}
                                              style={{ fontSize: 17 }}
                                            >
                                              •
                                              {itemdet.ingredientes[element]
                                                .name +
                                                " (" +
                                                itemdet.ingredientes[element]
                                                  .cantidad +
                                                ")"}
                                            </Col>
                                          </Row>
                                        );
                                      },
                                    )}
                                  </Col>
                                )}
                              {itemdet.anadidos &&
                                Object.keys(itemdet.anadidos).length > 0 && (
                                  <Col md={6}>
                                    <h6 style={{ color: "orangered" }}>
                                      <strong>Añadidos:</strong>
                                    </h6>
                                    {Object.keys(itemdet.anadidos).map(
                                      (element) => {
                                        return (
                                          <Row>
                                            <Col
                                              md={12}
                                              style={{ fontSize: 17 }}
                                            >
                                              {" •"}
                                              {itemdet.anadidos[element].name +
                                                " (" +
                                                itemdet.anadidos[element]
                                                  .cantidad +
                                                ")" +
                                                "\n "}
                                            </Col>
                                          </Row>
                                        );
                                      },
                                    )}
                                  </Col>
                                )}
                              {itemdet.note && itemdet.note !== "" && (
                                <Col md={12} style={{ textAlign: "center" }}>
                                  <h5>
                                    <strong>Nota:</strong>
                                  </h5>
                                  <h6>
                                    <strong>{itemdet.note}</strong>
                                  </h6>
                                </Col>
                              )}
                            </Row>
                          </Col>
                          <Col
                            md={1}
                            style={{
                              justifyItems: "center",
                              alignContent: "space-evenly",
                            }}
                          >
                            <Row
                              style={{
                                justifyContent: "space-evenly",
                                marginLeft: 10,
                                marginRight: 10,
                              }}
                            >
                              <i
                                className="bx bx-trash icon"
                                style={{
                                  fontSize: "30px",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                onClick={
                                  () => {
                                    setCancel(items + item.id);
                                    setPlatillCan([itemdet]);
                                  }
                                  // updatePlatillo(
                                  //   item.id,
                                  //   [itemdet],
                                  //   "CANCELADO",
                                  //   "",
                                  // )
                                }
                              ></i>
                              {/* {itemdet.note !== "" && (
                      <i
                        className="bx bx-note icon"
                        style={{
                          fontSize: "30px",
                          color: "orangered",
                          cursor: "pointer",
                        }}
                        // onClick={}
                      ></i>
                    )} */}
                              <Row
                                style={{
                                  padding: 0,
                                  cursor: "pointer",
                                  marginTop: 2,
                                }}
                                onClick={() => {
                                  if (itemdet.status === "ENTREGAR") {
                                    updatePlatillo(
                                      item.id,
                                      [itemdet],
                                      "ENTREGADO",
                                      "",
                                    );
                                  } else {
                                    updatePlatillo(
                                      item.id,
                                      [itemdet],
                                      "ENTREGAR",
                                      "",
                                    );
                                  }
                                }}
                              >
                                <Col md={12} style={{ height: 27 }}>
                                  <i
                                    className={
                                      itemdet.status === "ATENDIDO" ||
                                      itemdet.status === "PENDIENTE" ||
                                      itemdet.status === "CANCELADO"
                                        ? "bx bx-circle icon"
                                        : itemdet.status === "ENTREGADO"
                                          ? "bx bx-check-double icon"
                                          : "bx bx-check-circle icon"
                                    }
                                    style={{
                                      fontSize: "30px",
                                      color:
                                        itemdet.status === "ATENDIDO" ||
                                        itemdet.status === "PENDIENTE" ||
                                        itemdet.status === "CANCELADO"
                                          ? "gray"
                                          : "green",
                                    }}
                                  />
                                </Col>
                                <Col md={12}>
                                  <h6
                                    style={{
                                      textAlign: "center",
                                      fontSize: 12,
                                      fontWeight: "bold",
                                      color: "gray",
                                    }}
                                  >
                                    {itemdet.status === "ENTREGAR"
                                      ? "Listo"
                                      : itemdet.status === "ENTREGADO"
                                        ? "Entre- gado"
                                        : "No listo"}
                                    {/* {itemdet.status} */}
                                  </h6>
                                </Col>
                              </Row>
                            </Row>
                          </Col>
                        </Row>
                      ))}
                  </div>
                  {ordenes[items]?.filter((item) => item.status === "CANCELADO")
                    .length > 0 && (
                    <Accordion>
                      <CustomToggle
                        text={
                          ordenes[items]?.filter(
                            (item) => item.status === "CANCELADO",
                          ).length
                        }
                        eventKey={"cancelados"}
                      />
                      <Accordion.Collapse eventKey="cancelados">
                        <div className="nonDrag">
                          {ordenes[items]
                            ?.filter((item) => item.status === "CANCELADO")
                            .map((itemdet) => (
                              <Row
                                style={{
                                  marginBottom: 8,
                                  paddingTop: 3,
                                  paddingBottom: 3,
                                  border: "1px solid #ccc",
                                  boxShadow: "0px 4px 7px rgba(0, 0, 0, 0.15)",
                                  borderRadius: "10px",
                                }}
                              >
                                <Col
                                  md={2}
                                  style={{
                                    justifyItems: "center",
                                    alignContent: "space-evenly",
                                  }}
                                >
                                  <label className="marginlbl">
                                    <img
                                      id="logo_img"
                                      src={itemdet.img}
                                      width={"60rem"}
                                      height={"70rem"}
                                      style={{
                                        borderRadius: 10,
                                        objectFit: "cover",
                                      }}
                                      alt=""
                                    />
                                  </label>
                                </Col>
                                <Col
                                  md={1}
                                  style={{
                                    justifyItems: "center",
                                    alignContent: "space-evenly",
                                  }}
                                >
                                  <h3
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                      color: "orangered",
                                    }}
                                  >
                                    {itemdet.cantidad}
                                    <h6 style={{ color: "black" }}>pza</h6>
                                  </h3>
                                </Col>
                                <Col md={8} style={{ alignContent: "center" }}>
                                  <Row style={{ justifyContent: "center" }}>
                                    <Col md={12}>
                                      <h4
                                        style={{
                                          textAlign: "center",
                                          fontWeight: 700,
                                        }}
                                      >
                                        {itemdet.name}
                                      </h4>
                                    </Col>
                                    {itemdet.ingredientes &&
                                      Object.keys(itemdet.ingredientes).length >
                                        0 && (
                                        <Col md={6}>
                                          <h6 style={{ color: "orangered" }}>
                                            <strong>Ingredientes:</strong>
                                          </h6>
                                          {Object.keys(
                                            itemdet.ingredientes,
                                          ).map((element) => {
                                            return (
                                              <Row>
                                                <Col
                                                  md={12}
                                                  style={{ fontSize: 17 }}
                                                >
                                                  •
                                                  {itemdet.ingredientes[element]
                                                    .name +
                                                    " (" +
                                                    itemdet.ingredientes[
                                                      element
                                                    ].cantidad +
                                                    ")"}
                                                </Col>
                                              </Row>
                                            );
                                          })}
                                        </Col>
                                      )}
                                    {itemdet.anadidos &&
                                      Object.keys(itemdet.anadidos).length >
                                        0 && (
                                        <Col md={6}>
                                          <h6 style={{ color: "orangered" }}>
                                            <strong>Añadidos:</strong>
                                          </h6>
                                          {Object.keys(itemdet.anadidos).map(
                                            (element) => {
                                              return (
                                                <Row>
                                                  <Col
                                                    md={12}
                                                    style={{ fontSize: 17 }}
                                                  >
                                                    {" •"}
                                                    {itemdet.anadidos[element]
                                                      .name +
                                                      " (" +
                                                      itemdet.anadidos[element]
                                                        .cantidad +
                                                      ")" +
                                                      "\n "}
                                                  </Col>
                                                </Row>
                                              );
                                            },
                                          )}
                                        </Col>
                                      )}
                                    {itemdet.note && itemdet.note !== "" && (
                                      <Col
                                        md={12}
                                        style={{ textAlign: "center" }}
                                      >
                                        <h5>
                                          <strong>Nota:</strong>
                                        </h5>
                                        <h6>
                                          <strong>{itemdet.note}</strong>
                                        </h6>
                                      </Col>
                                    )}
                                  </Row>
                                </Col>
                                <Col
                                  md={1}
                                  style={{
                                    justifyItems: "center",
                                    alignContent: "space-evenly",
                                  }}
                                >
                                  <Row
                                    style={{
                                      justifyContent: "space-evenly",
                                      // marginLeft: 10,
                                      // marginRight: 10,
                                    }}
                                  >
                                    <Row
                                      style={{
                                        padding: 0,
                                        cursor: "pointer",
                                        marginTop: 2,
                                        margin: 0,
                                      }}
                                      onClick={() =>
                                        updatePlatillo(
                                          item.id,
                                          [itemdet],
                                          "ATENDIDO",
                                          "",
                                        )
                                      }
                                    >
                                      <Col
                                        md={12}
                                        style={{
                                          height: 27,
                                          margin: 0,
                                          padding: 0,
                                        }}
                                      >
                                        <i
                                          className="bx bx-check icon"
                                          style={{
                                            fontSize: "30px",
                                            color: "green",
                                            cursor: "pointer",
                                          }}
                                        ></i>
                                      </Col>
                                      <Col
                                        md={12}
                                        style={{
                                          margin: 0,
                                          padding: 0,
                                        }}
                                      >
                                        <h6
                                          style={{
                                            textAlign: "center",
                                            fontSize: 12,
                                            fontWeight: "bold",
                                            color: "gray",
                                          }}
                                        >
                                          recu- perar
                                        </h6>
                                      </Col>
                                    </Row>
                                  </Row>
                                </Col>
                              </Row>
                            ))}
                        </div>
                      </Accordion.Collapse>
                    </Accordion>
                  )}
                  <Row style={{ justifyContent: "center" }}>
                    <Col md={4}>
                      <Button
                        id="cancelarORD"
                        variant="na"
                        className="newbutton-style nonfilledtext-color fullspace nonDrag"
                        onClick={
                          () => {
                            setCancel(items + item.id);
                            setPlatillCan(ordenes[items]);
                          }
                          // updatePlatillo(
                          //   item.id,
                          //   ordenes[items],
                          //   "CANCELADO",
                          //   "",
                          // )
                        }
                      >
                        <FontAwesomeIcon icon={faTrash} />
                        Cancelar
                      </Button>
                    </Col>
                    <Col md={4}>
                      {item.table ? (
                        <Button
                          id="meseroORD"
                          variant="na"
                          className="newbutton-style nonfilledtext-color fullspace nonDrag"
                        >
                          <i
                            className="bx bx-user-voice icon"
                            style={{ fontSize: 17 }}
                          ></i>
                          Mesero
                        </Button>
                      ) : (
                        <Button
                          id="meseroORD"
                          variant="na"
                          className="newbutton-style nonfilledtext-color fullspace nonDrag"
                          onClick={() => Llamada(item)}
                        >
                          <i
                            className="bx bx-user-voice icon"
                            style={{ fontSize: 17 }}
                          ></i>
                          Cliente
                        </Button>
                      )}
                    </Col>
                    <Col md={4}>
                      <Button
                        id="entregarORD"
                        variant="na"
                        className="newbutton-style filled fullspace nonDrag"
                        ENTREGADO
                        onClick={() => {
                          if (
                            ordenes[items]?.filter(
                              (item) =>
                                item.status !== "CANCELADO" &&
                                item.status !== "ENTREGAR",
                            ).length > 0
                          ) {
                            updatePlatillo(
                              item.id,
                              ordenes[items],
                              "ENTREGAR",
                              "",
                            );
                          } else {
                            updatePlatillo(
                              item.id,
                              ordenes[items],
                              "ENTREGADO",
                              "",
                            );
                          }
                        }}
                      >
                        <i className="bx bx-check-circle icon"></i>
                        {ordenes[items]?.filter(
                          (item) =>
                            item.status !== "CANCELADO" &&
                            item.status !== "ENTREGAR",
                        ).length > 0
                          ? "Orden lista"
                          : "Entregar"}{" "}
                      </Button>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div className="nonDrag" style={estilos.contenido}>
                  <h4 style={{ textAlign: "center", color: "darkred" }}>
                    Motivo de la cancelacion:
                  </h4>
                  <select style={{ fontSize: 18 }} onChange={handleChange}>
                    {motivos.map((itemdet) => (
                      <option>{itemdet}</option>
                    ))}
                  </select>
                  <h5 style={{ textAlign: "center", marginTop: 15 }}>
                    Observacion(opcional)
                  </h5>
                  <Col md={12} style={{ paddingBottom: 18 }}>
                    <Form.Control
                      as="textarea"
                      id="notacamp"
                      rows={2}
                      value={nota}
                      sda
                      placeholder="Añade comentarios a tu pedido"
                      onChange={(e) => {
                        setNota(e.target.value);
                      }}
                    />
                  </Col>
                  <Row style={{ justifyContent: "center" }}>
                    <Col md={6}>
                      <Button
                        id="meseroORD"
                        variant="na"
                        className="newbutton-style nonfilledtext-color fullspace"
                        onClick={() => setCancel("")}
                      >
                        Volver
                      </Button>
                    </Col>
                    <Col md={6}>
                      <Button
                        id="cancelarORD"
                        variant="na"
                        className="newbutton-style nonfilledtext-color fullspace"
                        onClick={() => {
                          updatePlatillo(
                            item.id,
                            platillCan,
                            "CANCELADO",
                            motivos[motivo],
                            nota,
                          );
                          setCancel("");
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                        Cancelar
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Draggable>
        </div>
      ))}
    </>
  );
}
